import moment from 'moment-timezone';

import { EventsFilter } from '../interfaces';
import { EventTypeIdentifier, FleetUUIDs, VideoStatus } from '../enums';

export const defaultFilter = (): EventsFilter => ({
  dateFrom: moment().subtract(1, 'week').startOf('day').toISOString(),
  dateTo: moment().toISOString(),
  selectedFilters: [],
  license_plates: [],
  time_of_day: [0, 24],
  vehicle_types: [],
  active_lanes: [],
  route_ids: [],
  vehicle_ids: [],
  bus_stop_ids: [],
  device_ids: [],
});

export const fleetDefaultFilters = (fleetUUID: FleetUUIDs): EventsFilter => {
  const base = defaultFilter();

  if ([FleetUUIDs.MTA, FleetUUIDs.MTAReplay].includes(fleetUUID)) {
    return {
      ...base,
      selectedFilters: [EventTypeIdentifier.BUS_LANE_MATCH],
      human_review: true,
      media_statuses: [VideoStatus.publishedStr],
      whitelist: false,
    };
  }

  if (fleetUUID === FleetUUIDs.Chicago) {
    return {
      ...base,
      dateFrom: moment().subtract(14, 'day').startOf('day').toISOString(),
    };
  }

  if ([FleetUUIDs.SacRTBusStopShelter, FleetUUIDs.SacRTBusStopShelterActivePilot].includes(fleetUUID)) {
    return {
      ...base,
      dateFrom: moment().subtract(24, 'hours').toISOString(),
      include_tags: true,
      tag_operator: 'or',
      tags: {
        'td:776': 'ev:2233', // Graffiti SacRT bus stop shelter tags
        'td:772': 'ev:2230', // 'Sign missing/faded',
        'td:781': 'ev:2238', // 'Faded / missing advertisements',
        'td:774': 'ev:2231', // 'Pole is broken / missing',
        'td:775': 'ev:2232', // 'Broken glass',
        'td:777': 'ev:2234', // 'Lights out',
        'td:778': 'ev:2235', // 'Garbage overflow',
        // 'td:779': 'ev:2236', // 'Good condition',
        'td:780': 'ev:2237', // 'Other',
        'td:814': 'ev:2271', // Unattended Personal Property
      },
    };
  }

  return base;
};

export const fleetCleanFilters = (fleetUUID: FleetUUIDs): EventsFilter => {
  const base = defaultFilter();

  if ([FleetUUIDs.SacRTBusStopShelter, FleetUUIDs.SacRTBusStopShelterActivePilot].includes(fleetUUID)) {
    return {
      ...base,
      include_tags: true,
    };
  }

  return base;
};
